import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
export interface IUser {
  id: string
  type: string
  attributes: {
    activated: boolean
    country_code: string | null
    email: string
    first_name: string
    full_phone_number: string
    last_name: string
    type: string | null
    status: string
    role_id: number | null
    roles: string;
    gender: string | null
    full_name: string
    user_image_url: string
    age: number | null
    date_of_birth: string | null
    locations: string | null
    languages: string[]
    created_at: string
    updated_at: string
    unique_auth_id: string
  }
}

export interface ITalentList {
  id: string;
  name: string;
  profileImgUrl: string;
  role: string;
}
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  id: string;
  // Customizable Area Start
  talentList: IUser[];
  searchPopupId: string | undefined;
  anchorEl: HTMLElement | null, 
  open: boolean, 
  onClose: () => void;
  onResultClick: (user: IUser) => void
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  // Customizable Area End
}

interface SS {
  id: any;
}

export default class SearchTalentController extends BlockComponent<
  Props,
  S,
  SS
> {
    // Customizable Area Start
    // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
    ];

    this.state = {
      
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }
  async componentDidMount() {
    super.componentDidMount();
    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    // Customizable Area End
  }
  
  // Customizable Area Start
  // Function to calculate available space
    getAvailableSpaceBelow = () => {
        if (this.props.anchorEl) {
            const rect = this.props.anchorEl.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom - 5; // 5 for margin
            return spaceBelow > 0 ? spaceBelow : 0; // Ensure we return 0 if negative
        }
        return 0; // Default to 0 if no anchorEl
    };
  // Customizable Area End
}
